var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['apps-popover',_vm.popShow?'pop-show':'pop-hide']},[_c('div',{attrs:{"id":"popbar"}},[_c('aplication',{attrs:{"style1":_vm.style}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }